export default "__VITE_ASSET__DcfuXSbJ__"